export default "__VITE_ASSET__CTy46rVH__"